export function GuildHall({ current, resource }) {
    return (
        <div className="w-[84px] h-[40px] border-solid border flex flex-row items-center" style={{
            backgroundImage: `url(/liveGameIcons/BACKGROUND.png)`,
            borderColor: 'var(--main-color)'
        }}>
            <div className="flex flex-row items-center w-[48px] justify-end mr-[2px]">
                <h1 className="text-white text-lg">{current}</h1>
            </div>
            <div>
                <img className="w-[30px] aspect-auto mt-5 -ml-2 absolute" src={`/liveGameIcons/${resource?.toLowerCase()}.png`} alt="" />
                <img className="w-[40px] h-[40px]" src={`/liveGameIcons/unique/guildhall.png`} alt="" />
            </div>
        </div>
    )
}